export default "__VITE_ASSET__DsxzHJbq__"